export const formatUserPhoneForChecker = (phone: string) => {
  if (!phone.startsWith('+')) {
    return `+${phone}`;
  }

  return phone;
};
